module.exports = __webpack_public_path__ + "img/it-service-06.199acff8.webp";